import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { NewErrorMessageComponent } from '../../../pages/error-message/new-error-message/new-error-message.component';
import { ErrorMessage } from '../../../../../shared/models/error-message/error-message';
import { AgentActionDirective } from '../../../../directives/agent-action.directive';

@Component({
  selector: 'app-create-error-message-modal',
  imports: [NewErrorMessageComponent, AgentActionDirective],
  templateUrl: './create-error-message-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './create-error-message-modal.component.scss',
})
export class CreateErrorMessageModalComponent {
  @Output() public createErrorMessageTriggered = new EventEmitter<ErrorMessage>();
  public showModal = false;

  public openModal(): void {
    this.showModal = true;
  }

  public closeModal(): void {
    this.showModal = false;
  }

  public onErrorMessageCreated(errorMessage: ErrorMessage): void {
    this.createErrorMessageTriggered.emit(errorMessage);
    this.closeModal();
  }
}
